import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const Tabs = ({ content }) => {
  const tabs = Object.keys(content)
  const [selectedTab, setSelectedTab] = useState(tabs[0])
  const Component = content[selectedTab]
  const onTabClick = (tab) => {
    setSelectedTab(tab)
  }
  return (
    <div>
      <div className="wb-margin-top-xs">
        <wb-button-group>
          {tabs.map((tab) => (
            <label
              className={classnames(
                'wb-button wb-button--secondary wb-button--medium',
                { 'wb-button-group__item--selected': selectedTab === tab },
              )}
              key={tab}
            >
              <input
                type="radio"
                name="group"
                onChange={() => onTabClick(tab)}
              />
              {tab}
            </label>
          ))}
        </wb-button-group>

        <hr />
      </div>
      <div className="wb-padding-xs">
        <Component />
      </div>
    </div>
  )
}

Tabs.propTypes = {
  content: PropTypes.object,
}

export default Tabs
